<template>
  <a
    href="#"
    class="action-button animate yellow"
    @click="goNext"
    style="margin-top: 20px;"
  >
    <span style="font-weight: bolder;" class="text">
      {{ text }}
      <slot name="icon"></slot>
    </span>
  </a>
</template>
<script>
export default {
  props: ["text", "disable"],
  methods: {
    goNext() {
      if (!this.disable) this.$emit("goNext");
    }
  }
};
</script>
<style lang="scss" scoped>
a {
  --text-color: #965151;
}
.action-button {
  position: relative;
  padding: 0.8em 0.8em;
  margin-right: 1em;
  float: left;
  border-radius: 15px;
  font-size: 1.2em;
  color: var(--text-color);
  text-decoration: none;
  width: 13.5vw;
}

.yellow {
  background-color: #f7e0a5;
  border: 2px solid var(--text-color);
  border-bottom: 5px solid var(--text-color);

  &:hover {
    background-color: darken(#f7e0a5, 10%);
  }
}

.action-button:active {
  transform: translate(0px, 5px);
  -webkit-transform: translate(0px, 5px);
  border-bottom: 2px solid;
}
.text {
  text-align: justify;
}
</style>